import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M3.51514 8.46501L12.0001 16.95L20.4851 8.46501L19.0711 7.05001L12.0001 14.122L4.92914 7.05001L3.51514 8.46501Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronBigDown"
);
